// extracted by mini-css-extract-plugin
export default {"subAccordionLink":"setupAccordion_subAccordionLink__vPbF+","subAccordionLinkText":"setupAccordion_subAccordionLinkText__9TjM8"};